import Footer from "../components/footer.js";

//styling
import '../app/App.css';
import 'typeface-lato';

const NoPage = () => {
    return (
        <div className="centered" style={{backgroundColor: "#FFFBF3" , height: "100%"}}>
            <h1 className="header-text"><br />Error 404: Not found</h1>
            {<Footer />}
        </div>
    )
}

export default NoPage;